export default __webpack_public_path__ + "static/media/smile-rate-1.05e0a53a.svg";